import React, { useEffect, useState, useRef, useReducer, useCallback, useContext } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import _ from 'lodash'
import Widget from '../../dpe-usco/components/Widget/Widget'
import Select from '../../dpe-usco/components/Select/Select'
import TypeAhead from '../../dpe-usco/components/TypeAhead/TypeAhead'
import './CreateContract.scss'
import { getContractByProductionTemplateAndTypes, searchGrowers, searchCompaniesByType, getCompany, getGrower, getProductionPlan, getHighestRole } from '../../services/apiHelper'
import { GlobalContext, LanguageContext } from '../../services/context'
import { getSalesYear } from '../../services/apiHelper'


const NewContractDetailsWidget = ({ fieldDataCallback, updateRoot, _resellerId, _grainReceiverId, _growerId, _threePOId, _contractType, _contractYear, _contractLanguage, initGrowerDetails, initResellerDetails, initGrainReceiverDetails, _contractProductionPlanId }) => {
  const { register, unregister, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      annualContract: true,
      stewardship: true
    } 
  })

  const params = useParams()
  const { trackEvent } = useContext(GlobalContext)
  const langData =  useContext(LanguageContext)

  const [grainReceiverInput, setGrainReceiverInput] = useState('')
  const [grainReceiverId, setGrainReceiverId] = useState()
  const [defaultContractType, setDefaultContractType] = useState()
  const [defaultContractYear, setDefaultContractYear] = useState()
  const [defaultContractLanguage, setDefaultContractLanguage] = useState()
  
  const formReducer = (state, action) => {
    switch (action.type) {
      case 'PERMIT_SEARCH':
        return { ...state, permitSearch: true }
      case 'SET_GROWER_BY_CLICK':
        setValue([
          { growerName : action.payload.value },
          { growerId : action.payload.grower_sap_id }
        ])
        return { ...state, permitSearch: false, setBy: 'CLICK', growerDetails: action.payload  }
      case 'SET_RESELLER_BY_CLICK':
        setValue([
          { resellerName : action.payload.company_name },
          { resellerId : action.payload.sap_id }
        ])
        return { ...state, permitSearch: false, setBy: 'CLICK' }
      case 'SET_GRAIN_RECEIVER_BY_CLICK':
        trackEvent('grain_receiver_selected', { grainReceiverId: action.payload.company_id })
        setGrainReceiverInput(action.payload.company_name)
        return { ...state, permitSearch: false, setBy: 'CLICK', grainReceiverUpdate: true, grainReceiverId: action.payload.company_id }
      case 'CLEAR_TYPEAHEAD':{
        const newState = { ...state }
        const { inputType } = action.payload
        switch (inputType) {
          case 'reseller' :
            setValue([
              { resellerName : '' },
              { resellerId : '' }
            ])
            break
          case 'grain-receiver' :
            delete newState.grainReceiverId
            setGrainReceiverInput('')
            break
          case 'grower':
            delete newState.growerDetails
            setValue([
              { growerName : '' },
              { growerId : '' }
            ])
            break
          default:
            new Error()
        }
        return newState
      }
      case 'SET_BY_SAP_ID':
        trackEvent('grower_selected', { ...action.payload })
        setValue([{ growerName : action.payload.grower_name }])
        return { ...state, permitSearch: false, setBy: 'SAP_ID', growerDetails: state.growerDetails? state.growerDetails : action.payload }
      case 'SET_BY_FSAP_ID':
        trackEvent('reseller_selected', { ...action.payload })
        setValue([{ resellerName : action.payload.company_name }])
        return { ...state, permitSearch: false, setBy: 'FSAP_ID' }
      case 'SET_BY_GRAIN_RECEIVER_ID':
        trackEvent('grain_receiver_selected', { grainReceiverId: action.payload.company_id })
        setGrainReceiverInput(action.payload.company_name || '')
        return { ...state, permitSearch: false, setBy: 'GRAIN_RECEIVER_ID', grainReceiverUpdate: true, grainReceiverId: action.payload.company_id }
      case 'GRAIN_RECEIVER_STATUS':
        return { ...state, ...action.payload }
      default:
        return { ...state }
    }
  }
  const [formState, formDispatch] = useReducer(formReducer, { 
    permitSearch: true,
    grainReceiverUpdate: false,
    yearOptions: []
  })
  const [contractTypes, setContractTypes] = useState([])
  const watchAllInputs = watch()
  const watchGrowerName = watch('growerName', '')
  const watchResellerName = watch('resellerName', '')
  const watchGrowerId = watch('growerId', '')
  const watchResellerId  = watch('resellerId', '')
  const watchAnnualContract = watch('annualContract', true)
  const [growerData, setGrowerData] = useState()
  const [resellerData, setResellerData] = useState()
  const [grainReceiverData, setGrainReceiverData] = useState()
  const [grainReceiverLoadingState, setGrainReceiverLoadingState] = useState(false)
  const [growerLoadingState, setGrowerLoadingState] = useState(false)
  const [resellerLoadingState, setResellerLoadingState] = useState(false)
  const [languageOptions, setLanguageOptions] = useState([])
  const canceled = useRef(false)

  useEffect(() => {
    return ()=> {
      canceled.current = true
    }
  },[])

  const firstSetContractInfo = useRef(true)
  const setContractInfo = useCallback(async (company_id , contractProductionPlanId, contractLanguage) => {
    const response = await getContractByProductionTemplateAndTypes(contractProductionPlanId, true, 'production_plan_id', contractLanguage)
    if(!canceled.current){
      if (response){
        const { contract_template_id, contract_types, languages } = response
        updateRoot({ type: 'UPDATE_ROOT_CONTRACT_TEMPLATE_ID', payload: contract_template_id })
        updateRoot({ type: 'CLEAR_ERROR', payload: { grain_receiver_details: { no_contract_template: false } } })
        setContractTypes(contract_types)
        let filterLanguages = langData?.filter(x=> x.lang_value === 'en')
        if(languages?.length>0) {
          filterLanguages = langData?.filter(x=> languages.indexOf(x.lang_value) !== -1)
        }    
        const company_detail = await getCompany(company_id)
        if(company_detail?.supported_languages?.length > 0) {
          filterLanguages = filterLanguages?.filter(x=> company_detail?.supported_languages.indexOf(x.lang_value) !== -1)
        }
        const LanguagesOptionsData = filterLanguages?.map(x=>
          ({
            id: x.lang_value,
            value: x.lang_name
          }))
        setLanguageOptions(LanguagesOptionsData)
        if(_contractLanguage && firstSetContractInfo.current){
          setDefaultContractLanguage(_contractLanguage)
        }
        if(_contractType && firstSetContractInfo.current){
          firstSetContractInfo.current = false
          setDefaultContractType(_contractType)
          updateRoot({ type: 'UPDATE_ROOT_CONTRACT_TYPE', payload: _contractType })
        }
      } else {
        updateRoot({ type: 'SET_ERRORS', payload: { grain_receiver_details: { no_contract_template: true } } })
      }
    }
  }, [updateRoot, _contractType, _contractLanguage, langData])

  const firstPass = useRef(true)
  useEffect(()=> {
    const handleNewGrainReceiver = async () => {
      const response = await getProductionPlan(formState.grainReceiverId, 'company_id')
      let currentYear = 0
      await getSalesYear()?.then(res => {
        currentYear = Number(res?.data?.sales_year)
      })
      let newYearOptions = []
      if(!canceled.current){
        if(response?.length){
          response.forEach(plan => {
            if(plan.contract_year && (Number(plan.contract_year) === currentYear || Number(plan.contract_year) === currentYear-1 || Number(plan.contract_year) === currentYear+1) ){
              newYearOptions.push({
                production_plan_id: plan.production_plan_id,
                value: plan.contract_year
              })
            }
          })
        } else {
          updateRoot({ type: 'SET_ERRORS', payload: {  grain_receiver_details: { no_production_plan: true } } })
        }
        if(newYearOptions.length){
          formDispatch({ type: 'GRAIN_RECEIVER_STATUS', payload: { grainReceiverUpdate: false, yearOptions: newYearOptions } })
          if(_contractYear && firstPass.current){
            setDefaultContractYear(_contractYear)
          }
        }
      }
      firstPass.current = false
    }
    if (formState.grainReceiverUpdate){
      handleNewGrainReceiver()
    }
  }, [
    formState.grainReceiverUpdate, formDispatch, formState.grainReceiverId, updateRoot, _contractYear
  ])

  useEffect(()=> {
    if(watchAnnualContract) {
      unregister(['contractStart', 'contractEnd'])
      updateRoot({ type: 'REMOVE_ROOT_CONTRACT_YEAR_START_AND_END' })
    } else {
      unregister('contractYear')
      updateRoot({ type: 'REMOVE_ROOT_CONTRACT_YEAR' })
    }
  }, [
    watchAnnualContract, unregister, updateRoot
  ])

  useEffect(()=> {
    if(watchAllInputs.contractStart || watchAllInputs.contractEnd) {
      updateRoot({ type: 'UPDATE_ROOT_CONTRACT_YEAR_START_OR_END', payload: { contract_start: watchAllInputs.contractStart, contract_end: watchAllInputs.contractEnd } })
    } 
  }, [
    watchAllInputs.contractStart, watchAllInputs.contractEnd, updateRoot
  ])

  const prevAllInputs = useRef()

  useEffect(()=> {
    if(prevAllInputs.current) {
      if(!_.isEqual(prevAllInputs.current, watchAllInputs)){
        prevAllInputs.current = watchAllInputs
      }
    } else {
      prevAllInputs.current = watchAllInputs
    }
    
  }, [watchAllInputs])

  const prevGrowerDetails = useRef()

  useEffect(()=> {
    if(prevGrowerDetails.current || formState.growerDetails) {
      if(!_.isEqual(prevGrowerDetails.current, formState.growerDetails)){
        prevAllInputs.current = formState.growerDetails
      }
    } else {
      prevGrowerDetails.current = formState.growerDetails
    }
  }, [formState.growerDetails])

  useEffect(()=> {
    if(_threePOId) {
      setValue('grainReceiverId', _threePOId)
    }
  }, [_threePOId, setValue])

  useEffect(()=> {
    if(_growerId) {
      setValue('growerId', _growerId)
    }
  }, [_growerId, setValue])
  

  useEffect(()=> {
    if(_resellerId && !canceled.current) {
      setValue('resellerId', _resellerId)
    }
  }, [_resellerId, setValue])

  useEffect(()=> {
    if(_grainReceiverId && _contractProductionPlanId && _contractLanguage && !canceled.current) {
      setContractInfo(_grainReceiverId, _contractProductionPlanId, _contractLanguage)
      prevGrainReceiverId.current = _grainReceiverId
      setGrainReceiverId(_grainReceiverId)
    }
  }, [
    _grainReceiverId, setContractInfo, setValue, _contractProductionPlanId, _contractLanguage
  ])


  const handleSelectContractType = option => {
    setValue('_contractType', option.contract_type_id)
    updateRoot({ type: 'UPDATE_ROOT_CONTRACT_TYPE', payload: option.contract_type_id })
    trackEvent('contract_type_set', { contractType: option })
  }

  const handleSelectYear = option => {
    setValue('contractYear', option.value)
    updateRoot({ type: 'UPDATE_ROOT_CONTRACT_YEAR', payload: { contractYear: option.value, production_plan_id: option.production_plan_id } })
    trackEvent('contract_year_set', { contractYear: option })
    setContractInfo(_grainReceiverId, option.production_plan_id)
    
  }

  const onSubmit = () => {
    return null
  }

  const _growerCallback = item=> {
    formDispatch({ type: 'SET_GROWER_BY_CLICK', payload: item })
    updateRoot({ type: 'UPDATE_GROWER_DETAILS', payload: item })
  }

  const _resellerCallback = item=> {
    formDispatch({ type: 'SET_RESELLER_BY_CLICK', payload: item })
    updateRoot({ type: 'UPDATE_RESELLER_DETAILS', payload: item })
  }

  const _grainReceiverCallback = item=> {
    setDefaultContractYear()
    setDefaultContractType()
    formDispatch({ type: 'SET_GRAIN_RECEIVER_BY_CLICK', payload: item })
    updateRoot({ type: 'UPDATE_GRAIN_RECEIVER_DETAILS', payload: item })
    // setContractInfo(item.company_id)
  }

  const handleChangeGrainReceiver = e => {
    e.preventDefault()
    setGrainReceiverInput(e.target.value)
  }

  const growerDebounce = useRef()
  useEffect(()=> {
    const search = () => {
      setGrowerLoadingState(true)
      searchGrowers(watchGrowerName)
        ?.then(res => {
          const sortRes = res.sort((a, b) => (a.value?.toLowerCase() > b.value?.toLowerCase()) ? 1 : -1)
          if(!canceled.current){
            setGrowerData(sortRes)
            if(watchGrowerName === prevGrowerSearch.current || prevGrowerSearch.current.length < 3){
              setGrowerLoadingState(false)
            }
          }
        })
    }
    if(formState.permitSearch) {
      if(prevGrowerSearch.current !== watchGrowerName){
        if(watchGrowerName.length === 0 && prevGrowerSearch.current && prevGrowerSearch.current.length !== 0) {
          formDispatch({ type: 'CLEAR_TYPEAHEAD', payload: { inputType: 'grower' } })
          updateRoot({ type: 'REMOVE_GROWER_DETAILS' })
        }else if(watchGrowerName.length >= 3) {
          clearTimeout(growerDebounce.current)
          growerDebounce.current = setTimeout(search, 300)
        }
      }
    } else {
      formDispatch({ type: 'PERMIT_SEARCH' })
    }
  }, [
    watchGrowerName, formState.permitSearch, formDispatch, setGrowerData, updateRoot
  ])

  const resellerDebounce = useRef()
  useEffect(()=> {
    const search = () => {
      setResellerLoadingState(true)
      searchCompaniesByType(watchResellerName, 'reseller')
        .then(res => {
          if(!canceled.current){
            setResellerData(res)
            if(watchResellerName === prevResellerSearch.current || prevResellerSearch.current.length < 3){
              setResellerLoadingState(false)
            }
          }
        })
    }
    if(formState.permitSearch) {
      if(prevResellerSearch.current !== watchResellerName){
        if(watchResellerName.length === 0 && prevResellerSearch.current && prevResellerSearch.current.length !== 0) {
          formDispatch({ type: 'CLEAR_TYPEAHEAD', payload: { inputType: 'reseller' } })
          updateRoot({ type: 'REMOVE_RESELLER_DETAILS' })
        }
        if(watchResellerName.length >= 3) {
          clearTimeout(resellerDebounce.current)
          resellerDebounce.current = setTimeout(search, 300)
        }
      }
    } else {
      formDispatch({ type: 'PERMIT_SEARCH' })
    }
  }, [
    watchResellerName, formState.permitSearch, formDispatch, setResellerData, updateRoot
  ])

  const grainReceiverDebounce = useRef()
  useEffect(()=> {
    const search = () => {
      searchCompaniesByType(grainReceiverInput, [
        'grain-receiver', '3PO', 'syngenta'
      ])
        ?.then(res => {
          if(!canceled.current){
            setGrainReceiverData(res)
            if(grainReceiverInput === prevGrainReceiverSearch.current || prevGrainReceiverSearch.current.length < 3){
              setGrainReceiverLoadingState(false)
            }
          }
        })
    }

    if(formState.permitSearch) {
      if(prevGrainReceiverSearch.current !== grainReceiverInput){
        if(grainReceiverInput.length === 0 && prevGrainReceiverSearch.current && prevGrainReceiverSearch.current.length !== 0) {
          formDispatch({ type: 'CLEAR_TYPEAHEAD', payload: { inputType: 'grain-receiver' } })
          updateRoot({ type: 'REMOVE_GRAIN_RECEIVER_DETAILS' })
        }
        else if(grainReceiverInput.length >= 3) {
          clearTimeout(grainReceiverDebounce.current)
          setGrainReceiverLoadingState(true)
          grainReceiverDebounce.current = setTimeout(search, 300)
        }
      }
    } else {
      formDispatch({ type: 'PERMIT_SEARCH' })
    }
  }, [
    grainReceiverInput, formState.permitSearch, formDispatch, setGrainReceiverData, updateRoot
  ])

  const prevGrowerSearch = useRef()
  const prevResellerSearch = useRef()
  const prevGrainReceiverSearch = useRef()
  useEffect(() => {
    if (prevGrowerSearch.current !== watchGrowerName){
      prevGrowerSearch.current = watchGrowerName
    }
    if (prevResellerSearch.current !== watchResellerName){
      prevResellerSearch.current = watchResellerName
    }
    if (prevGrainReceiverSearch.current !== grainReceiverInput){
      prevGrainReceiverSearch.current = grainReceiverInput
    }
  })

  
  useEffect(()=> {
    if (watchGrowerId.length && watchGrowerId.length > 5) {
      setGrowerLoadingState(true)
      let initResponse = {}
      if(initGrowerDetails)
        initResponse = {
          grower_name: initGrowerDetails?.first + ' ' + initGrowerDetails?.last,
          grower_first: initGrowerDetails?.first,
          grower_last: initGrowerDetails?.last,
          grower_address: initGrowerDetails?.address,
          grower_city: initGrowerDetails?.city,
          grower_state: initGrowerDetails?.state,
          grower_zipcode: initGrowerDetails?.zipcode,
          grower_phone: initGrowerDetails?.phone,
          grower_sap_id: initGrowerDetails?.sap_id
        }

      getGrower(watchGrowerId, 'sap_id')
        ?.then(response => {
          if(!canceled.current){
            if(response){
              formDispatch({ type: 'SET_BY_SAP_ID', payload: response })
              updateRoot({ type: 'UPDATE_GROWER_DETAILS', payload: response })
              fieldDataCallback(response.grower_sfdc_id)
            } else {
              formDispatch({ type: 'SET_BY_SAP_ID', payload: initResponse })
              updateRoot({ type: 'UPDATE_GROWER_DETAILS', payload: initResponse })
            }
            setGrowerLoadingState(false)
          }
        })
    }
  }, [
    watchGrowerId, fieldDataCallback, formDispatch, updateRoot, initGrowerDetails
  ])
  
  useEffect(()=> {
    if (watchResellerId?.length && watchResellerId.length >= 10) {
      setResellerLoadingState(true)
      let initResponse = {}
      if (initResellerDetails) {
        initResponse =
          {
            company_id: initResellerDetails?.reseller_id,
            company_name: initResellerDetails?.reseller_name,
            address1: initResellerDetails?.address,
            address2: initResellerDetails?.address2,
            city: initResellerDetails?.city,
            state: initResellerDetails?.state,
            zipcode: initResellerDetails?.zipcode,
            sap_id: initResellerDetails?.sap_id
          }
      }
      getCompany(watchResellerId, 'sap_id')
        .then(response => {
          if(!canceled.current){
            if(response){
              formDispatch({ type: 'SET_BY_FSAP_ID', payload: response })
              updateRoot({ type: 'UPDATE_RESELLER_DETAILS', payload: response })
            } else {
              formDispatch({ type: 'SET_BY_FSAP_ID', payload: initResponse })
              updateRoot({ type: 'UPDATE_RESELLER_DETAILS', payload: initResponse })
            }
            setResellerLoadingState(false)
          }
        })
    }
  }, [
    watchResellerId, formDispatch, updateRoot, initResellerDetails
  ])
  
  const prevGrainReceiverId = useRef()
  
  useEffect(()=> {
    if (grainReceiverId?.length) {
      setGrainReceiverLoadingState(true)
      let initResponse = {}
      if (initGrainReceiverDetails) {
        initResponse =
          {
            company_id: initGrainReceiverDetails?.grain_receiver_id,
            company_name: initGrainReceiverDetails?.grain_receiver_name,
            address1: initGrainReceiverDetails?.address,
            address2: initGrainReceiverDetails?.address2,
            city: initGrainReceiverDetails?.city,
            state: initGrainReceiverDetails?.state,
            zipcode: initGrainReceiverDetails?.zipcode,
            sap_id: initGrainReceiverDetails?.sap_id
          }
      }
      getCompany(grainReceiverId)
        .then(response => {
          if(!canceled.current){
            if(response){
              formDispatch({ type: 'SET_BY_GRAIN_RECEIVER_ID', payload: response })
              updateRoot({ type: 'UPDATE_GRAIN_RECEIVER_DETAILS', payload: response })
            } else {
              formDispatch({ type: 'SET_BY_GRAIN_RECEIVER_ID', payload: initResponse })
              updateRoot({ type: 'UPDATE_GRAIN_RECEIVER_DETAILS', payload: initResponse })
            }
            if (prevGrainReceiverId.current !== grainReceiverId){
              // setContractInfo(grainReceiverId)
              prevGrainReceiverId.current = grainReceiverId
            }
            setGrainReceiverLoadingState(false)
          }
        })
    }
  }, [grainReceiverId, formDispatch, updateRoot, setContractInfo, initGrainReceiverDetails])

  useEffect(() => {
    if(params.contract_id){
      getHighestRole().then(highestRoleData => {
        const userInfoData  = {
          'user_id': highestRoleData.user_id,
          'user_name': highestRoleData.first+ ' ' + highestRoleData.last,
          'user_email': highestRoleData.email
        }
        updateRoot({ type: 'UPDATE_CONTRACT_ID', payload: { newContractId: params.contract_id, userInfo: userInfoData } })
      })
      
    }
  }, [params.contract_id, updateRoot])

  let dates = (
    <div className='w45% df fxdrc aifs mb20'>
      <label className='mb10' htmlFor='contractYear'>Contract year</label>
      <Select
        defaultId={defaultContractYear}
        placeholder='Select a year'
        handleSelection={handleSelectYear}
        options={formState.yearOptions}
        name='contractYear'
        id='contractYear'
        reset={false}
        disabled={params.contract_id && true}
        className={params.contract_id ? 'c-gray2' : ''}
      />
    </div>
  )
  if (!watchAnnualContract) {
    dates = (
      <>
        <div className='w45%'>
          <div className='df mb10'>Contract start</div>
          <input type='date' name='contractStart' ref={register()}/>
        </div>

        <div className='w45% mb20'>
          <div className='df mb10'>Contract end</div>
          <input type='date' name='contractEnd' ref={register()}/>
        </div>
      </>
    )
  }

  return (
    <Widget title='Contract details'>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <div className='bb1-s-lightgray mt20 mb10 df aic jcfs'>
          <div className='mb20 mr20 df aic jcfs'>
            <input className='w15' type='checkbox' id='stewardship' name='stewardship' ref={register()}/>
            <label htmlFor='stewardship'>Stewardship</label>
          </div>
          <div className='mb20 df aic jcfs'>
            <input className='w15' type='checkbox' id='annualContract' name='annualContract' ref={register()}/>
            <label htmlFor='annualContract'>Annual contract</label>
          </div>
        </div> */}

        <div className='df mb10 bb1-s-lightgray jcsb'>
          <div className='w45%'>
            <label className='df mb10' htmlFor='grainReceiverName'>Grain receiver</label>
            <TypeAhead className={`mb20 ${params.contract_id ? 'c-gray2' : ''}`} id='grainReceiverName' name='grainReceiverName'
              value={grainReceiverInput}
              onChange={handleChangeGrainReceiver}
              item_id='company_id'
              item_value='company_name'
              data={grainReceiverData}
              callback={_grainReceiverCallback}
              loading={grainReceiverLoadingState}
              disabled={params.contract_id && true}
            />
          </div>
        </div> 

        <div className='bb1-s-lightgray mt20 mb10'>
          <div className='w45% df fxdrc aifs mb20'>
            <span className='mb10'>Contract type</span>
            <Select
              defaultValue={defaultContractType}
              placeholder='Select an option'
              handleSelection={handleSelectContractType}
              options={contractTypes}
              name='_contractType'
              disabled={params.contract_id && true}
              className={params.contract_id ? 'c-gray2' : ''}
            />
          </div>
        </div>

        <div className='df fxdrc bb1-s-lightgray mb10 jcsb'>
          <div className='df jcsb'>
            {dates}
          </div>
        </div>

        <div className='df mb10 bb1-s-lightgray jcsb' data-testid='growerRow'>
          <div className='w45%'>
            <label className='df mb10' htmlFor='growerId'>Grower SAP Id</label>
            <input className={`mb20 ${params.contract_id ? 'c-gray2' : ''}`} type='text' id='growerId' name='growerId' ref={register()} disabled={params.contract_id && true}/>
          </div>

          <div className='w45%'>
            <label className='df mb10' htmlFor='growerName'>Search grower name</label>
            <TypeAhead className={`mb20 ${params.contract_id ? 'c-gray2' : ''}`} id='growerName' name='growerName' ref={register()}
              item_id='grower_sap_id'
              item_value='value'
              data={growerData}
              callback={_growerCallback}
              loading={growerLoadingState}
              disabled={params.contract_id && true}
            />
          </div>
        </div> 

        <div className='df jcsb'>
          <div className='w45%'>
            <label className='df mb10' htmlFor='resellerId'>Reseller number (FSAP ID)</label>
            <input  className={`mb20 ${params.contract_id ? 'c-gray2' : ''}`} name='resellerId' id='resellerId' ref={register()} disabled={params.contract_id && true}/>
          </div>
          <div className='w45%'>
            <label className='df mb10' htmlFor='resellerName'>Search reseller name</label>
            <TypeAhead  className={`mb20 ${params.contract_id ? 'c-gray2' : ''}`} id='resellerName' name='resellerName' ref={register()}
              item_id='company_id'
              item_value='company_name'
              data={resellerData}
              callback={_resellerCallback}
              loading={resellerLoadingState}
              disabled={params.contract_id && true}
            />
          </div>
        </div> 


        <div className='df fxdrc bb1-s-lightgray mb10 jcsb'>
          <div className='df jcsb'>
            <div className='w45% df fxdrc aifs mb20'>
              <label className='mb10' htmlFor='contractYear'>Contract language</label>
              <Select
                defaultId={defaultContractLanguage}
                placeholder='Select language'
                options={languageOptions}
                name='contractLanguage'
                id='contractLanguage'
                reset={false}
                disabled={params.contract_id && true}
                className={params.contract_id ? 'c-gray2' : ''}
              />
            </div>
          </div>
        </div>


      </form>

    </Widget>
  )
}

export default NewContractDetailsWidget